module.exports = __webpack_public_path__ + "static/media/cellfinate_antes_despues_3.962eb459.jpg";